import { useState, useEffect, useContext, useCallback } from "react";
import axios from "axios";
import { GlobalContext } from "../../Context/GlobalContext";

const MODULE_ORDER = [
  "Dashboard",
  "Whatsapp",
  "Billing",
  "Settings",
];

const useSideNav = () => {
  const { baseUrl, basicAuth, userID } = useContext(GlobalContext);

  const [modules, setModules] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSidebar = useCallback(async () => {
    if (!userID) return;

    setLoading(true);

    try {
      const res = await axios.post(
        `${baseUrl}/Entitlement/v1.0/fetchEntitlementModuleDetails`,
        { userid: userID },
        {
          headers: {
            Authorization: basicAuth,
            "Content-Type": "application/json",
          },
        }
      );

      if (res.data.responseCode === "00") {
  const apiModules = res.data.data || [];

   sessionStorage.setItem(
    "entitlement",
    JSON.stringify(apiModules)
  );
  
        //  Sorting Logic
        const sortedModules = [...apiModules].sort((a, b) => {
          const aIndex = MODULE_ORDER.findIndex(
            (name) =>
              name.toLowerCase() ===
              (a.module_name || "").toLowerCase()
          );

          const bIndex = MODULE_ORDER.findIndex(
            (name) =>
              name.toLowerCase() ===
              (b.module_name || "").toLowerCase()
          );

          if (aIndex === -1 && bIndex === -1) return 0;
          if (aIndex === -1) return 1;
          if (bIndex === -1) return -1;

          return aIndex - bIndex;
        });

        setModules(sortedModules);
      }
    } catch (err) {
      console.error("Sidebar API error", err);
    } finally {
      setLoading(false);
    }
  }, [userID, baseUrl, basicAuth]);

  useEffect(() => {
    if (!userID) return;
    fetchSidebar();
  }, [userID, fetchSidebar]);

  return { modules, loading };
};

export default useSideNav;